import React from "react";
import { Anchor, Flex, Group, Paper, Stack, Text, Title } from "@mantine/core";
import type { IChecklist } from "@mctypes/checklist.types";
import { RelatedChecklistsByReviewIdMenu } from "./RelatedChecklistsByReviewIdMenu";
import DkApprovalPanel from "./DkApprovalPanel";

const documentControlGuideUrl =
  "https://multiconsultas.sharepoint.com/sites/DSP/SitePages/Hvordan%20Dokumentkontroll%20utf%C3%B8res%20i%20CORE.aspx?isSPOFile=1&xsdata=MDV8MDJ8fDNkMGQ2NWI0NGVmZTQwN2Q3N2E3MDhkZWFiNjdiYTJmfDgxYWI3NDc4OGQzYzQ3MzY4YjU0N2YyYmZkOWZhMjBlfDB8MHw2MzkxMzY2NTkxMjY4NDMzMDN8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T21GbU56WTJaREJqTFRFeVpHRXROR0kxWXkwNE1EUmpMVFZoTkdSalpqQXdPREpsTTE5ak1HTTNZVFUxWlMwNU1qZzVMVFF3WTJVdFlXUmxaQzFqWkdJMFpHSTBPV013TmpaQWRXNXhMbWRpYkM1emNHRmpaWE12YldWemMyRm5aWE12TVRjM09EQTJPVEV3T1RnNE5BPT18NGUzMWFlZmI2YWYyNGMxMmZlOTcwOGRlYWI2N2JhMmV8Y2M1NTc0MjQxMTY1NDUzNDk2OWRmNDZmMTFkYzc1MGQ%3D&sdata=aW5aMnB3N3hYVHdoYVpwczhuUmtUaEx1LzRYdjhTQi9mWmFXQW00Y0Z1Yz0%3D&ovuser=81ab7478-8d3c-4736-8b54-7f2bfd9fa20e%2Cperst%40multiconsult.no&OR=Teams-HL&CT=1778144486874&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI1MC8yNjA0MDQwMTcyMyJ9&linkOpenTime=1778144486880";

const DoksamChecklistBanner: React.FC<{ checklist: IChecklist }> = ({ checklist }) => {
  const docId = checklist?.doksam?.docId ?? "";

  return (
    <Paper radius="md" p="sm" m="sm" bg="dark.8" withBorder>
      <Flex justify="space-between" align="center" gap="md" wrap="nowrap">
        <Stack gap={0} style={{ flex: 1, minWidth: 0 }}>
          <Title order={4} c="white">
            Core dokument: <b>{docId}</b>
          </Title>
        </Stack>

        <Group align="center" gap="md" wrap="nowrap" style={{ marginLeft: "auto", flexShrink: 0 }}>
          <DocumentControlGuideNotice />

          <RelatedChecklistsByReviewIdMenu />

          <DkApprovalPanel />
        </Group>
      </Flex>
    </Paper>
  );
};

export default DoksamChecklistBanner;

const DocumentControlGuideNotice: React.FC = () => (
  <Paper
    p="xs"
    radius={0}
    withBorder
    bg="rgba(255,255,255,0.03)"
    style={{
      maxWidth: 320,
      borderColor: "rgba(255,255,255,0.55)",
      boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.28)",
      textAlign: "center",
    }}
  >
    <Text size="sm" fw={600} c="gray.2" lh={1.25}>
      Knappene Send til SK og Send til Godkjenning er tilgjengelig i dokumentkontrollpanelet.
    </Text>
    <Anchor
      href={documentControlGuideUrl}
      target="_blank"
      rel="noopener noreferrer"
      size="sm"
      c="gray.2"
      fw={700}
      td="underline"
    >
      Se veiledning for ny Dokumentkontroll.
    </Anchor>
  </Paper>
);
